// extracted by mini-css-extract-plugin
export var aniSpin = "p_d";
export var container = "p_m";
export var content = "p_t";